import React from 'react'

export default function DPA(): JSX.Element {
  return (
    <div className="p-5 w-full h-full flex flex-1 justify-center items-center font-Spartan">
      <div className="flex flex-col gap-2">
        <h1 className="font-lg font-bold">Data Privacy Agreement</h1>
        <span className="font-md">Coming Soon</span>
      </div>
    </div>
  )
}
